import React from "react";
import styles from "../onboard.module.css";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import SignInInput from "../../../common/SigninInput/signinInput";
import Dropdown from "../../Dropdown/dropdown";
import CommonButton from "../../CommonButton/CommonButton";

function RemitterBankForm({
  accountHolderName,
  setAccountHolderName,
  valid,
  accountNumber,
  setAccountNumber,
  handleChangeOption,
  accountTypeError,
  bankNameError,
  IFSC,
  ifscError,
  setIfsc,
  handleBlur,
  bankAddress,
  setBankAddress,
  nextSectionError,
  checkIfValid,
  loading,
  themeColor,
  bankList,
  handleBankSelectionOption
}) {
  const RemitterAccountType = [
    {
      label: "Saving",
      value: "savings",
    },
    {
      label: "Current",
      value: "current",
    },
  ];
  
  return (
    <div>
      <Row>
        <Col md={4}>
          <SignInInput
            name="AccountHolderName"
            label="Account Holder Name"
            placeholder="Enter Full Name"
            type="text"
            value={accountHolderName}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              setAccountHolderName(event.target.value);
            }}
            isInvalid={valid.accountHolderName}
          />
        </Col>
        <Col md={4}>
          <Dropdown
            options={bankList}
            label="Select Bank"
            heading="Select Bank"
            onChange={handleBankSelectionOption}
            search={true}
          />
          {bankNameError !== "" ? (
            <div className={styles.errorState}>{bankNameError}</div>
          ) : (
            ""
          )}
          {/* <SignInInput
            name="BankName"
            label="Bank Name"
            placeholder="Enter Bank Name"
            type="text"
            value={bankName}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              setBankName(event.target.value);
            }}
            isInvalid={valid.bankName}
          /> */}
        </Col>
        <Col md={4}>
          <SignInInput
            name="AccountNumber"
            label="Account Number"
            placeholder="Enter Account Number"
            type="number"
            value={accountNumber}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              setAccountNumber(event.target.value);
            }}
            onPaste={(e) => {
              e.preventDefault();
              return false;
            }}
            onCopy={(e) => {
              e.preventDefault();
              return false;
            }}
            isInvalid={valid.accountNumber}
          />
        </Col>
      </Row>
      <Row className="pt-2">
        <Col md={4}>
          <Dropdown
            options={RemitterAccountType}
            label="Select Account Type"
            heading="Account Type"
            onChange={handleChangeOption}
          />
          {accountTypeError !== "" ? (
            <div className={styles.errorState}>{accountTypeError}</div>
          ) : (
            ""
          )}
        </Col>
        <Col md={4}>
          <SignInInput
            name="IFSC"
            label="Enter IFSC"
            placeholder="Enter IFSC"
            type="text"
            value={IFSC}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              const upperCaseValue = event.target.value.toUpperCase();
              if (event.target.value.length <= 11) setIfsc(upperCaseValue);
            }}
            isInvalid={valid.IFSC}
            onBlur={(event) => {
              handleBlur(event);
            }}
            errorMessage={ifscError}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="bankAddress"
            label="Enter Bank Address"
            placeholder="Enter bank address"
            type="text"
            value={bankAddress}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              setBankAddress(event.target.value);
            }}
            isInvalid={valid.bankAddress}
          />
        </Col>
      </Row>
      <Row className="pt-3 mt-3">
        <div className={styles.errorState}>{nextSectionError}</div>
        <CommonButton
          title="Next"
          onClick={checkIfValid}
          loading={loading}
          disabled={loading}
          width={"150px"}
        />
          {/* <Button
            className={styles.button}
            // className="w-100"
            onClick={checkIfValid}
            disabled={loading}
            style={{background: themeColor}}
          >
            {loading && (
              <Spinner animation="border" className={styles.spinnerColor} style={{borderColor: themeColor, borderRightColor: "white"}}/>
            )}
            Next
          </Button> */}
      </Row>
    </div>
  );
}

export default RemitterBankForm;
